export default __webpack_public_path__ + "static/media/clock-in-duration.4b2d3191.svg";